export default {
    LOGIN: (params) => ({type:'LOGIN', ...params}),
    LOGOUT: (params) => ({type:'LOGOUT', ...params}),
    IFRAME_LOGIN: (params) => ({type: 'IFRAME_LOGIN', ...params})
}